import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

export function useGps(enabled, postUrl, deniedMsg) {
  const [pos, setPos] = useState(null);
  const [error, setError] = useState("");
  const lastSent = useRef(0);

  useEffect(() => {
    if (!enabled) return undefined;
    if (!navigator.geolocation) {
      setError("This device does not support GPS location");
      return undefined;
    }
    const id = navigator.geolocation.watchPosition(
      (p) => {
        const loc = { lat: p.coords.latitude, lng: p.coords.longitude, heading: p.coords.heading, accuracy: p.coords.accuracy, speed: p.coords.speed };
        setPos(loc);
        setError("");
        if (postUrl && Date.now() - lastSent.current > 4000) {
          lastSent.current = Date.now();
          api.post(postUrl, loc).catch(() => {});
        }
      },
      () => setError(deniedMsg),
      { enableHighAccuracy: true, maximumAge: 3000, timeout: 15000 }
    );
    return () => {
      navigator.geolocation.clearWatch(id);
    };
  }, [enabled, postUrl, deniedMsg]);

  return { pos, error };
}

export const useDriverGps = (enabled) =>
  useGps(enabled, "/driver/location", "Location access is off — allow location so passengers can see your taxi");

export const googleNavUrl = (dest) => `https://www.google.com/maps/dir/?api=1&destination=${dest.lat},${dest.lng}&travelmode=driving`;

export function kmBetween(a, b) {
  const r = 6371;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * r * Math.asin(Math.sqrt(h)) * 1.3;
}
